import { DentalNotationFormat } from '@/shared/api/protocol-ts/model/dto_organization_pb';

import { ToothWithDetections } from '@/entities/tooth';

export type JawQuartilesRanges = {
  [key: string]: number[];
};

export type ChangeToothNumberPopupProps = {
  isOpen: boolean;
  title: string;
  selectedTooth: ToothWithDetections;
  dentalNotationFormat: DentalNotationFormat;
  className?: string;
  animatedToothNumber?: number;
  pendingNumber?: number;
  onChangeToothNumber: (
    tooth: ToothWithDetections,
    toothNumber: number,
  ) => void;
  onRemoveTooth: (tooth: ToothWithDetections) => void;
  selectTooth: (tooth?: ToothWithDetections) => void;
};

export enum JawQuartiles {
  topLeft = 'topLeft',
  topRight = 'topRight',
  bottomLeft = 'bottomLeft',
  bottomRight = 'bottomRight',
  topLeftPrimary = 'topLeftPrimary',
  topRightPrimary = 'topRightPrimary',
  bottomLeftPrimary = 'bottomLeftPrimary',
  bottomRightPrimary = 'bottomRightPrimary',
}
